import type { RedocRawOptions } from "redoc";
import { SideNavStyleEnum } from "redoc";

/**
 * Redoc renders its own DOM from its own theme object, so it can't read our CSS
 * tokens — the palette has to be handed to it per theme. Only the parts that
 * actually flip are branched; the status hues (success / error / warning) read
 * on both backgrounds, and the right panel is the code column, which is dark in
 * either theme.
 */
function redocTheme(isDark: boolean) {
  return {
    logo: {
      gutter: "20px",
    },
    colors: {
      primary: {
        main: isDark ? "#8f9df2" : "#4A69BD",
      },
      success: {
        main: "#00875A",
        light: "#57D9A3",
      },
      error: {
        main: "#DE350B",
        light: "#FF5630",
      },
      warning: {
        main: "#FF8B00",
        light: "#FFB84D",
      },
      text: {
        primary: isDark ? "#e4e4e7" : "#172B4D",
        secondary: isDark ? "#b0b6c0" : "#6B778C",
      },
    },
    typography: {
      fontFamily: "Inter, system-ui, -apple-system, sans-serif",
    },
    sidebar: {
      backgroundColor: isDark ? "#18181c" : "#F4F5F7",
      textColor: isDark ? "#e4e4e7" : "#172B4D",
    },
    rightPanel: {
      backgroundColor: "#0E1624",
      textColor: "#F4F5F7",
    },
  };
}

export function apiAccessRedocOptions(isDark: boolean): RedocRawOptions {
  return {
    theme: redocTheme(isDark),
    nativeScrollbars: false,
    hideDownloadButton: false,
    expandResponses: "200,201",
    pathInMiddlePanel: true,
    disableSearch: false,
    requiredPropsFirst: true,
    sortPropsAlphabetically: false,
    sideNavStyle: SideNavStyleEnum.IdOnly,
    menuToggle: false,
  };
}
